import { Command } from 'pos/common';
import * as DeliveryNoteStore from './DeliveryNoteStore';
import { Res, Permission, DeliveryNoteDTO } from 'core/api';
import { Preconditions } from 'core/infrastructure-next';
import * as NotePreconditions from './Preconditions';
import { reopenDocument, ReopenDocumentResult } from 'pos/modules/helpers/document-reopening';

declare global {
	interface CommandType {
		reopenDeliveryNote: (note: DeliveryNoteDTO) => Promise<Result<ReopenDocumentResult>>
	}
}

Command.register('reopenDeliveryNote', Preconditions.and(Preconditions.ensure(Permission.DeliveryNote_Reopen), Preconditions.ensureIsNotLite), async (note: DeliveryNoteDTO): Promise<Result<ReopenDocumentResult>> => {
	return reopenDocument({
		title: Res.Web.REOPEN_DELIVERY_NOTE(),
		canReopen: () => NotePreconditions.ensureCanBeReopened(note),
		reopen: location => DeliveryNoteStore.reopen(note.Id, location),
		reopenInTicket: (location, targetId) => DeliveryNoteStore.reopenInTicket(note.Id, location, targetId),
	});
});